export default {
      id: "reefer-info-3-usage",
      viewBox: "0 0 28 34",
      url: __webpack_public_path__ + "img/icons.svg#reefer-info-3",
      toString: function () {
        return this.url;
      }
    }